module.exports = __webpack_public_path__ + "static/media/sparguthaben-2.08931a91.png";